// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pzHg4","rootNoMargin":"styles_rootNoMargin__2xauL"};